'use client';

import { c as _c } from "react/compiler-runtime";
import { Clock } from 'lucide-react';
export function FaixaAguardandoTriagem() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] bg-neutral-100 text-neutral-700"><Clock aria-hidden="true" className="h-5 w-5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-3 rounded-[16px] border border-solid border-neutral-200 bg-neutral-50 p-4">{t0}<div className="min-w-0 flex-1"><p className="text-sm font-medium text-neutral-700">Aguardando triagem da Secretaria</p><p className="text-xs text-neutral-600">A Secretaria irá conferir os dados e documentos do processo. Nenhuma ação é necessária pelas partes neste momento.</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}